// Tags the GTM signup events with how the person signed up. GA4's provider-
// labeled 'Social Signup' event has never been recorded in production, so
// without this field the Google/Microsoft/email split is unmeasured.
export const SIGNUP_METHOD = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
  EMAIL: 'email',
} as const;

export type SignupMethod = (typeof SIGNUP_METHOD)[keyof typeof SIGNUP_METHOD];

const OAUTH_GOOGLE_STRATEGY = 'oauth_google';
const OAUTH_MICROSOFT_STRATEGY = 'oauth_microsoft';
const SIGNUP_METHOD_KEY = 'signup_method';

const KNOWN_METHODS: readonly string[] = Object.values(SIGNUP_METHOD);

export function signupMethodForStrategy(strategy: string): SignupMethod {
  if (strategy === OAUTH_GOOGLE_STRATEGY) {
    return SIGNUP_METHOD.GOOGLE;
  }
  if (strategy === OAUTH_MICROSOFT_STRATEGY) {
    return SIGNUP_METHOD.MICROSOFT;
  }
  return SIGNUP_METHOD.EMAIL;
}

// An OAuth signup leaves the page for the provider, so the method is kept in
// sessionStorage until OnboardingLayout emits signup_success on the way back.
export function rememberSignupMethod(method: SignupMethod): void {
  sessionStorage.setItem(SIGNUP_METHOD_KEY, method);
}

export function takeSignupMethod(): SignupMethod | undefined {
  const stored = sessionStorage.getItem(SIGNUP_METHOD_KEY);
  sessionStorage.removeItem(SIGNUP_METHOD_KEY);
  return stored && KNOWN_METHODS.includes(stored)
    ? (stored as SignupMethod)
    : undefined;
}
